<template>
  <div class="search">
    <transition name="search-flyout">
      <template v-if="flyoutOpen">
        <SearchFlyout :query="query" @closeFlyout="closeFlyout"/>
      </template>
    </transition>
    <template v-if="flyoutOpen">
      <div class="search__overlay" @click="closeFlyout"></div>
    </template>
  </div>
</template>

<script>
import SearchFlyout from './SearchFlyout.vue';

export default {
  props: {
    query: String,
  },
  data() {
    return {
      flyoutOpen: false,
      classes: {
        searchOpen: 'search-open'
      },
    }
  },
  components: {
    SearchFlyout,
  },
  methods: {
    openFlyout() {
      this.flyoutOpen = true;
      document.body.classList.add(this.classes.searchOpen);
    },
    closeFlyout() {
      this.flyoutOpen = false;
      document.body.classList.remove(this.classes.searchOpen);
    }
  },
  mounted() {
    const searchbarClasses = document.querySelectorAll('.js-search');

    searchbarClasses.forEach((el) => {
      el.addEventListener('click', () => {
        this.openFlyout();
      });
    });
  }
}
</script>
